import { useEffect, useState } from 'react';

const MINUTE_MS = 60_000;

/** The time, re-read every minute: an alert's age is shown to the minute, so a screen left open keeps counting. */
export function useMinuteClock(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), MINUTE_MS);
    return () => clearInterval(timer);
  }, []);
  return now;
}
